import Vue from "vue";
// echarts
import echarts from '@/assets/js/echarts';

Vue.prototype.$echarts = echarts;
